module.exports = __webpack_public_path__ + "img/sec.20bed5b8.png";